// Mirrors LeadCategoryRef (DataTypes/leads.ts) — same shape convention
// used for a category reference on read.
export type TemplateCategoryRef = {
  id: number;
  name: string;
  slug?: string;
};

export type EmailTemplateType = {
  id: number;
  name: string;
  subject: string;
  body_html: string;
  body_text: string;
  category: TemplateCategoryRef | null;
  owner: { id: number; email: string } | null;
  is_public: boolean;
  created_at: string;
  updated_at: string;
};

export type EmailTemplatesQueryParams = {
  category_id?: number | string;
};

// Fields the add/edit template form submits. category_id is the raw value
// the backend expects on write (unlike EmailTemplateType's nested `category`,
// which is what it returns on read).
export type EmailTemplateFormFields = {
  name: string;
  category_id: string;
  subject: string;
  body_html: string;
  body_text: string;
  is_public: boolean;
  custom_signature_html: string;
  is_promotional: boolean;
};

export const emptyEmailTemplateFields: EmailTemplateFormFields = {
  name: '',
  category_id: '',
  subject: '',
  body_html: '',
  body_text: '',
  is_public: false,
  custom_signature_html: '',
  is_promotional: false,
};

type EmailTemplateSignaturePreview = {
    source: 'custom' | 'shared';
    rendered_html: string;
    placeholders_used: string[];
    unrecognized_placeholders: string[];
}

// Mirrors EmailTemplate.render()'s recognized tokens server-side.
export const KNOWN_TEMPLATE_PLACEHOLDERS = [
  'company_name',
  'city',
  'decision_maker_name',
  'decision_maker_title',
  'decision_maker_email',
  'sender_name',
  'sender_position',
];

export type EmailTemplatePreviewResult = {
  subject: string;
  body_html: string;
  body_text: string;
  available_placeholders: string[];
  placeholders_used: string[];
  unrecognized_placeholders: string[];
  signature: EmailTemplateSignaturePreview;
};
